/**
 * hero carousel banner and promotion bar slider code ( Start ).
 * Initializes a slider within a given container element.
 *
 * @param {HTMLElement} container The parent element containing the slider.
 * @param {string} nextButtonSelector CSS selector for the "next" button.
 * @param {string} prevButtonSelector CSS selector for the "previous" button.
 * @param {string} slidesSelector CSS selector for the slides container.
 * @param {string} slideSelector CSS selector for individual slide elements.
 */
function initializeSlider(container, nextButtonSelector, prevButtonSelector, slidesSelector, slideSelector) {
    // Check if all required elements exist
    if (container && container.querySelector(nextButtonSelector) && container.querySelector(prevButtonSelector)) {
        let slides = container.querySelector(slidesSelector);
        let slideElements = container.querySelectorAll(slideSelector);
        let totalSlides = slideElements.length;
        let index = 1; // Start at the first actual slide
        let slideWidth = 100;
        let autoSlideInterval;

        // Clone first and last slides for seamless looping
        let firstClone = slideElements[0].cloneNode(true);
        let lastClone = slideElements[totalSlides - 1].cloneNode(true);

        slides.appendChild(firstClone);
        slides.prepend(lastClone);

        // Set initial position without animation
        slides.style.transition = "none";
        slides.style.transform = `translateX(${-index * slideWidth}%)`;

        /**
         * Displays the current slide with optional animation.
         *
         * @param {boolean} animated Whether to animate the transition (default: true).
         */
        function showSlide(animated = true) {
            slides.style.transition = animated ? "transform 0.9s ease-in-out" : "none";
            slides.style.transform = `translateX(${-index * slideWidth}%)`;
        }

        /**
         * Advances to the next slide, resetting auto-slide interval.
         */
        function nextSlide() {
            index++;
            showSlide();
            resetAutoSlide();

            // If we've reached the end, reset to the first slide
            if (index >= totalSlides + 1) {
                setTimeout(() => {
                    slides.style.transition = "none";
                    index = 1;
                    showSlide(false);
                }, 900);
            }
        }

        /**
         * Goes back to the previous slide, resetting auto-slide interval.
         */
        function prevSlide() {
            index--;
            showSlide();
            resetAutoSlide();

            // If we've reached the beginning, reset to the last slide
            if (index <= 0) {
                setTimeout(() => {
                    slides.style.transition = "none";
                    index = totalSlides;
                    showSlide(false);
                }, 900);
            }
        }

        /**
         * Resets the auto-slide interval.
         */
        function resetAutoSlide() {
            clearInterval(autoSlideInterval);
            autoSlideInterval = setInterval(nextSlide, 5000);
        }

        // Start auto-slide after a slight delay
        setTimeout(() => {
            autoSlideInterval = setInterval(nextSlide, 5000);
        }, 1000);

        // Attach event listeners to navigation buttons
        container.querySelector(nextButtonSelector).addEventListener('click', nextSlide);
        container.querySelector(prevButtonSelector).addEventListener('click', prevSlide);

        // Swipe functionality
        let startX, endX;

        slides.addEventListener('touchstart', (event) => {
            startX = event.touches[0].clientX;
        });

        slides.addEventListener('touchmove', (event) => {
            endX = event.touches[0].clientX;
        });

        slides.addEventListener('touchend', () => {
            if (startX > endX + 50) {
                nextSlide(); // Swipe left
            } else if (startX + 50 < endX) {
                prevSlide(); // Swipe right
            }
        });
    }
}

// Initialize sliders on page load
document.addEventListener('DOMContentLoaded', function () {
    // Initialize hero banner carousels
    document.querySelectorAll('.hero-banner-carousel-slider').forEach(container => {
        initializeSlider(container, '.hero-banner-carousel-next', '.hero-banner-carousel-prev', '.hero-banner-carousel-slides', '.hero-banner-carousel-slide');
    });

    // Initialize other sliders
    document.querySelectorAll('.slider-container').forEach(container => {
        initializeSlider(container, '.arrow-right', '.arrow-left', '.slides', '.slide');
    });
});
/* * hero carousel banner and promotion bar slider code ( end ). */


/* 
* code to handle play button on video in product details section feature (start) 
*/
document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('titanBrandVideo');
  const playButton = document.getElementById('playButton');

  // Show play button initially
  playButton.style.display = 'flex';

  /**
   * Toggle play/pause state of the video and update the visibility of the play button.
   */
  function togglePlayPause() {
      if (video.paused) {
          video.play();
          hidePlayButton();
      } else {
          video.pause();
          showPlayButton();
      }
  }

  // Helper functions to manage play button visibility
  function showPlayButton() {
      playButton.style.display = 'flex';
  }

  function hidePlayButton() {
      playButton.style.display = 'none';
  }

  // Event listeners for play/pause functionality
  [playButton, video].forEach((element) => {
      element.addEventListener('click', (event) => {
          event.preventDefault();
          togglePlayPause();
      });

      element.addEventListener('touchend', (event) => {
          event.preventDefault();
          togglePlayPause();
      });
  });

  // Event listeners for video state changes
  video.addEventListener('pause', showPlayButton);
  video.addEventListener('play', hidePlayButton);
  video.addEventListener('canplay', () => {
      if (video.paused) {
          showPlayButton(); // Show play button only when the video is paused and ready to play.
      }
  });
});
/* * code to handle play button on video in product details section feature (start) */

// code to set underline in product description on PDP (start)
 document.querySelectorAll('div#descTextBlock a').forEach(function(anchor) {
  anchor.style.textDecoration = 'underline';
  anchor.style.color = 'rgba(var(--color-foreground))';
});
// code to set underline in product description on PDP (end)